export default __webpack_public_path__ + "static/media/047-great mosque of samarra.75c28794.svg";